<template>
  <div class="status-list scroll-styling rounded-lg ">
    <div class="relative overflow-x-auto">
      <table
        class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
      >
        <thead
          class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" class="px-6 py-3">Попытка</th>
            <th scope="col" class="px-6 py-3">Курс</th>
            <th scope="col" class="px-6 py-3">Статус</th>
            <th scope="col" class="px-6 py-3">Дата решения</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(el, ind) in courses"
            :key="ind"
            :class="el.is_archived ? 'bg-gray-50 opacity-60 border-b' : 'bg-white border-b dark:bg-gray-800 dark:border-gray-700'"
          >
            <td class="px-6 py-4">
              {{ el.attempt_number }} / 4
              <span
                v-if="el.is_archived"
                class="ml-1 px-1 py-0.5 bg-gray-200 text-gray-500 rounded text-xs"
              >Архив</span>
            </td>
            <td class="px-6 py-4">{{ el.course }}</td>
            <td class="px-6 py-4">{{ el.status }}</td>
            <td class="px-6 py-4">{{ formatDate(el.approved_at) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_CLIENT, HEADERS_TOKEN_JSON } from "@/const/uri";

export default {
  data() {
    return {
      clientToken: null,
      courses: [],
    };
  },
  beforeMount() {
    // this.clientToken = localStorage.getItem("client_token");
    // if (!this.clientToken) {
    //   this.$router.push({
    //     name: "ClientLogin",
    //   });
    // }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const date = new Date(dateStr);
      return new Intl.DateTimeFormat('ru-RU', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(date);
    },
    async loadData() {
      await axios({
        method: "GET",
        url: API_CLIENT.courseStatus,
        data: {},
        headers: HEADERS_TOKEN_JSON(),
      })
        .then((e) => {
          const data = e.data.data;
          this.courses = data.courses;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  props: {},
};
</script>